<h2 mat-dialog-title class="dialog-title">{{ 'ADD_WORK' | translate }}</h2>

<mat-dialog-content [formGroup]="workLogForm" class="dialog-content">
  <p class="project-chip" *ngIf="projectName">
    <mat-icon>folder_open</mat-icon>
    {{ projectName }}
  </p>

  <div class="form-grid">
    <div class="form-field">
      <label class="field-label" for="wl-title">Title *</label>
      <input id="wl-title" class="field-control" type="text" formControlName="title" placeholder="Work log title" />
      <p class="field-error" *ngIf="workLogForm.get('title')?.invalid && workLogForm.get('title')?.touched">
        Title is required.
      </p>
    </div>

    <div class="form-field">
      <label class="field-label" for="wl-date">{{ 'DATE' | translate }} *</label>
      <input id="wl-date" class="field-control" type="date" formControlName="logDate" [max]="today" />
    </div>

    <div class="form-field">
      <label class="field-label" for="wl-hours">Hours worked</label>
      <input id="wl-hours" class="field-control" type="number" min="0" max="24" step="0.5" formControlName="hoursWorked" />
    </div>

    <div class="form-field">
      <label class="field-label" for="wl-progress">Progress %</label>
      <input id="wl-progress" class="field-control" type="number" min="0" max="100" formControlName="progressPercentage" />
    </div>

    <div class="form-field">
      <label class="field-label" for="wl-status">Status</label>
      <select id="wl-status" class="field-control" formControlName="status">
        <option value="in_progress">In Progress</option>
        <option value="completed">Completed</option>
        <option value="blocked">Blocked</option>
        <option value="on_hold">On Hold</option>
      </select>
    </div>

    <div class="form-field">
      <label class="field-label" for="wl-priority">Priority</label>
      <select id="wl-priority" class="field-control" formControlName="priority">
        <option value="low">Low</option>
        <option value="medium">Medium</option>
        <option value="high">High</option>
        <option value="critical">Critical</option>
      </select>
    </div>
  </div>

  <div class="form-field">
    <label class="field-label" for="wl-description">{{ 'DESCRIPTION' | translate }} *</label>
    <textarea
      id="wl-description"
      class="field-control field-textarea"
      rows="4"
      formControlName="description"
      placeholder="Describe work completed today..."
    ></textarea>
    <p class="field-error" *ngIf="workLogForm.get('description')?.invalid && workLogForm.get('description')?.touched">
      {{ 'DESCRIPTION_REQUIRED' | translate }}
    </p>
  </div>

  <div class="form-field">
    <label class="field-label">Attachments</label>
    <div class="attachment-actions">
      <button type="button" class="btn-attach" (click)="openCameraCapture()" [disabled]="submitting || capturingGeo">
        <mat-icon>photo_camera</mat-icon>
        {{ capturingGeo ? 'Getting GPS…' : 'Camera + GPS' }}
      </button>
      <button type="button" class="btn-attach" (click)="openGalleryPicker()" [disabled]="submitting">
        <mat-icon>photo_library</mat-icon>
        Gallery
      </button>
    </div>
    <input
      #cameraInput
      type="file"
      accept="image/*"
      capture="environment"
      class="hidden-input"
      (change)="onCameraSelected($event)"
      [disabled]="submitting"
    />
    <input
      #galleryInput
      type="file"
      multiple
      accept=".png,.jpg,.jpeg,image/*"
      class="hidden-input"
      (change)="onGallerySelected($event)"
      [disabled]="submitting"
    />
    <div *ngIf="fileError" class="field-error">{{ fileError }}</div>
  </div>

  <div class="image-preview" *ngIf="attachments.length > 0">
    <div *ngFor="let item of attachments; let i = index" class="preview-item">
      <img [src]="item.preview" alt="" />
      <span class="geo-badge" *ngIf="item.fromCamera && item.latitude != null" title="Geo-tagged">
        <mat-icon>my_location</mat-icon>
      </span>
      <p class="geo-coords" *ngIf="item.latitude != null && item.longitude != null">
        {{ formatCoords(item.latitude, item.longitude) }}
      </p>
      <button
        type="button"
        class="preview-remove"
        (click)="removeAttachment(i)"
        [disabled]="submitting"
        title="Remove"
      >
        ×
      </button>
    </div>
  </div>

  <div *ngIf="serverError" class="server-error">
    <strong>Could not save:</strong> {{ serverError }}
  </div>
</mat-dialog-content>

<div class="dialog-footer">
  <button type="button" class="btn-secondary" (click)="cancel()" [disabled]="submitting">
    {{ 'CANCEL' | translate }}
  </button>
  <button
    type="button"
    class="btn-primary"
    (click)="save()"
    [disabled]="workLogForm.invalid || submitting"
  >
    {{ submitting ? 'Saving…' : ('SAVE' | translate) }}
  </button>
</div>
